import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OtherFilters } from "~/components/Filters/OtherFilters/OtherFilters";
import { SingleFilterContainer } from "~/components/Filters/SingleFilters/SingleFilterContainer";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { addOtherFilterValueAction, clearOtherFiltersValuesAction, removeOtherFilterValueAction } from "~/store/filters/actions";
import { hasOtherFiltersValuesSelector, selectedOtherFiltersSelector } from "~/store/filters/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const SingleOtherFilters = /*#__PURE__*/ memo((param)=>{
    let { otherFilters, onApplyClick } = param;
    const dispatch = useDispatch();
    const hasValues = useAirSelector(hasOtherFiltersValuesSelector);
    const selectedFilters = useSelector(selectedOtherFiltersSelector);
    const { searchImprovements } = useTemporaryFeatureFlags();
    const clearValues = useCallback(()=>{
        dispatch(clearOtherFiltersValuesAction());
    }, [
        dispatch
    ]);
    const onTypeSelectedChange = useCallback((filter, isSelected)=>{
        if (isSelected) {
            dispatch(addOtherFilterValueAction({
                filter
            }));
        } else {
            dispatch(removeOtherFilterValueAction({
                filter
            }));
        }
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        dispatch,
        onApplyClick,
        searchImprovements
    ]);
    return /*#__PURE__*/ _jsx(SingleFilterContainer, {
        hasValues: hasValues,
        currentFilter: "other",
        onClearClick: clearValues,
        onApplyClick: onApplyClick,
        children: /*#__PURE__*/ _jsx(OtherFilters, {
            otherFilters: otherFilters,
            onTypeSelectedChange: onTypeSelectedChange,
            selectedFilters: selectedFilters
        })
    });
});
SingleOtherFilters.displayName = "SingleOtherFilters";
